export default "__VITE_ASSET__C9KV2yUg__"